import { render, staticRenderFns } from "./PhoneNumberModal.vue?vue&type=template&id=85261bfc"
import script from "./PhoneNumberModal.vue?vue&type=script&lang=js"
export * from "./PhoneNumberModal.vue?vue&type=script&lang=js"
import style0 from "./PhoneNumberModal.vue?vue&type=style&index=0&id=85261bfc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports